import React from 'react';
import cn from 'classnames';
import ScorecardResultsGrid from 'components/pure/scorecards/ScorecardResultsGrid';
import './ScorecardResults.styl';
import NavActions from 'actions/NavActions';
import {overrideName} from 'components/nav/renderers/GridOverrideNav';
import Button from '@material-ui/core/Button';

/**
 * <ScorecardResults /> render a grid of search results for a given `Scorecard` object
 */
export default class ScorecardResults extends React.PureComponent {
  static defaultProps = {
    topNav: overrideName,
  };

  componentDidMount() {
    NavActions.setNavOverride.defer(this.props.topNav, {
      name: this.props.scorecard.name,
      hasMultipleScorecards: this.props.hasMultipleScorecards,
      goToChooser: this.props.goToChooser,
      goBack: this.props.goBack,
      exitScorecard: this.props.goBack,
    });
  }

  componentWillUnmount() {
    NavActions.clearNavOverride.defer();
  }

  render() {
    return (
      <div className={cn('scorecard-results', {'new-call-card': this.props.newCallCard})}>
        {this.props.newCallCard && this.props.hasMultipleScorecards && (
          <Button className="back-to-scorecards" onClick={this.props.goToChooser}>
            Back to Scorecards
          </Button>
        )}
        <ScorecardResultsGrid
          scorecard={this.props.scorecard}
          labelScheme={this.props.schemeLabels.find(
            l => l.scoringScheme === this.props.scorecard.scoringScheme
          )}
          sessionUser={this.props.sessionUser}
          goToEditScreen={this.props.goToEditScreen}>
          {this.props.children}
        </ScorecardResultsGrid>
      </div>
    );
  }
}
